export default __webpack_public_path__ + "static/media/img10.67fb3275.png";